import React from 'react';
import Footer from '../../molecules/Footer';
import Header from '../../molecules/Header';

/**
 * メール配信設定 エラー画面
 */
const NotFoundPage: React.FC = () => {
  return (
    <div>
      <Header />
      <div className='md-container'>
        <h2 className='md-headline'>ご利用ありがとうございます</h2>
        <p className='md-text'>
          ページが見つかりませんでした。
          <br />
          ご指定のURLに誤りがあるか、お探しのページが削除された可能性があります。
          <br />
          <br />
          配信停止または再開をご希望の場合は、配信元の店舗へご連絡いただき配信のお手続きをお願いいたします。
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
